module.exports = __webpack_public_path__ + "img/avatar7.4b1098d8.png";